export class ActiveTrail {

    constructor (private container:JQuery) {
        $(document).on('nav',this.onNav);
    }

    private onNav=()=>{
        this.container.find('li').removeClass('is-active-trail is-active');
        for (let e of this.container.find('a')) {
            if (e.getAttribute('href') && e.pathname==location.pathname && !e.hash) {
                $(e).closest('li').addClass('is-active');
                $(e).parents('li').addClass('is-active-trail');
            }
        }
    };

}

export {};